export function collectServiceCodes(row: any): string[] {
  const fromServiceCodes = Array.isArray(row.serviceCodes)
    ? row.serviceCodes
    : [];
  const fromServices = Array.isArray(row.services)
    ? row.services
        .map((s: any) => s?.code)
        .filter((x: any): x is string => typeof x === "string")
    : [];
  return Array.from(new Set([...fromServiceCodes, ...fromServices]));
}
